import { boolean, create, Describe, nullable, string, type } from 'superstruct';

import { SapParameters } from '~extension/web2print/model/SapParameters';

export const SapParametersValidator: Describe<SapParameters> = type({
  loginUrl: string(),
  hasValidHookUrl: boolean(),
  hookUrl: nullable(string()),
});

export function makeSapParameters(raw: unknown) {
  try {
    const sapParameters = create(raw, SapParametersValidator);
    return sapParameters;
  } catch (err) {
    console.error(err);
  }
}
